import { Directive, Input, OnChanges } from '@angular/core';
import { TabDirective } from 'ngx-bootstrap/tabs';

@Directive({
  selector: '[hbTabOrder]',
})
export class TabOrderDirective implements OnChanges {
  @Input() hbTabOrder = 0;
  @Input() activeTab: number = 0; // default active tab to the first tab

  constructor(private tab: TabDirective) { }

  ngOnChanges() {
    (this.tab as any).__tabOrder = +this.hbTabOrder;
    this.tab.tabset.tabs.sort((a: any, b: any) => a.__tabOrder - b.__tabOrder);
    // set the active tab.
    this.tab.tabset.tabs[this.activeTab].active = true;
  }
}
